import React, { FC } from 'react';

import { Icon } from '@rbilabs/components-library';

import { IconContainer } from './toast.styled';
import { ToastType } from './types';

export const ToastTypeLogo: FC<{ type: ToastType }> = ({ type }) => {
  switch (type) {
    case 'success':
      return (
        <IconContainer>
          <Icon color="white" icon="check" width="1rem" height="1rem" />
        </IconContainer>
      );
    case 'info':
    case 'default':
      return (
        <IconContainer>
          <Icon color="white" icon="info" width="1rem" height="1rem" />
        </IconContainer>
      );
    case 'warning':
    case 'error':
      return (
        <IconContainer>
          <Icon color="white" icon="caution" width="1rem" height="1rem" />
        </IconContainer>
      );
    default:
      return null;
  }
};
